
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class TeacherPaymentsDialog extends Serenity.EntityDialog<TeacherPaymentsRow, any> {
        protected getFormKey() { return TeacherPaymentsForm.formKey; }
        protected getIdProperty() { return TeacherPaymentsRow.idProperty; }
        protected getLocalTextPrefix() { return TeacherPaymentsRow.localTextPrefix; }
        protected getNameProperty() { return TeacherPaymentsRow.nameProperty; }
        protected getService() { return TeacherPaymentsService.baseUrl; }
        protected getDeletePermission() { return TeacherPaymentsRow.deletePermission; }
        protected getInsertPermission() { return TeacherPaymentsRow.insertPermission; }
        protected getUpdatePermission() { return TeacherPaymentsRow.updatePermission; }

        protected form = new TeacherPaymentsForm(this.idPrefix);

    }
}